// extracted by mini-css-extract-plugin
module.exports = {"jobSearchList__recommend__wrapper":"jobSearchList__recommend__wrapper"};